import { AppThunk } from 'store/types';
import { getOrderByIDAsyncAction } from './orderInformation/orderInformationSlice';
import { getTitleReport } from './titleInformation/dispatch';
import { getHoaDetailsAction } from './orderHoa/slices';
import { eAPITags } from '../../API/eAPITags';
import { SigningAppointmentApi } from '../../API/order/signingAppointment/SigningAppointmentAPI';

//There are a few things that have to be done to load an order. This makes it easier to do from the various spots it can be done at.
export const loadOrderAsyncAction =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    if (orderId) {
      SigningAppointmentApi.util.invalidateTags([{ type: eAPITags.SigningAppointmentListData, id: orderId }]);
      const [order] = await Promise.all([
        dispatch(getOrderByIDAsyncAction(orderId)).unwrap(),
        dispatch(getHoaDetailsAction(orderId)),
      ]);

      if (order.transaction.titleCommitmentId) {
        await dispatch(getTitleReport(orderId));
      }
    }
  };
